"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAltiumHarnessFile = parseAltiumHarnessFile;
exports.validateAltiumHarnessFile = validateAltiumHarnessFile;
const Util_1 = require("../../../Util");
const altiumValidation_1 = require("../../altiumValidation");
const AltiumHarnessRegex = /^([^=\n]+)=(([^,\n]+)(,([^,\n]+))*)?$/;
function parseAltiumHarnessFile(contents) {
    const lines = contents.split('\n');
    const harnesses = [];
    for (let line of lines) {
        line = line.trim();
        if (line.length === 0) {
            continue;
        }
        const match = AltiumHarnessRegex.exec(line);
        if (!match) {
            continue;
        }
        const name = match[1].trim();
        const signalsString = match[2] || '';
        const signals = signalsString.length > 0 ? signalsString.split(',').map((s) => s.trim()) : [];
        harnesses.push({
            name,
            signals,
        });
    }
    return harnesses;
}
async function validateAltiumHarnessFile(filename, fileContents) {
    if (!filename.toLowerCase().endsWith('.harness')) {
        return undefined;
    }
    const textContents = (await (0, Util_1.getBlobTextClean)(fileContents)).trim();
    const lines = textContents.split('\n');
    for (const line of lines) {
        const trimmedLine = line.trim();
        if (trimmedLine.length === 0) {
            continue;
        }
        if (!AltiumHarnessRegex.test(trimmedLine)) {
            return undefined;
        }
    }
    return {
        referencedFiles: [],
        metadata: {
            [altiumValidation_1.AltiumProjectMetadataKey.FileType]: 'Altium Harness',
            [altiumValidation_1.AltiumProjectMetadataKey.Harness]: parseAltiumHarnessFile(textContents),
        },
    };
}
//# sourceMappingURL=altiumHarness.js.map